export const REMOVE_DOUBLESPACE = /\s{2,}/g
export const STRIP_HTML = /<[^>]*>?/gm
export const BREAKING_SPACES = /&nbsp;/g
export const GREATHER_THAN = /&gt;/g
export const SPAN_TAG = /<\/?span[^>]*>/g
export const CS_LINE_BREAK = /\n/g
export const AMPERSAND = /&amp;/g
export const EM_TAG = /<\/?em[^>]*>/g
export const SPACE_BETWEEN_TAGS = />\s+</g
export const ANCHOR_HREF_VALUE = /href="([^"]*)"/g
